/**
 * ¿Qué notas de la bitácora son CONVERSACIÓN y cuáles son cambios internos?
 *
 * ⚠️ ESPEJO de `EVENTOS_CONVERSACION` en `arktickets/domain/eventos_bitacora.py`.
 * Si agregas un evento allá, agrégalo aquí (y al revés) o el filtro miente.
 *
 * `Nota.tipo` dice QUIÉN escribió (manual / sistema), no QUÉ es. El vaivén con
 * Jimi y Queclink lo escribe un worker —así que es `sistema`— pero es la
 * conversación misma: filtrar por `tipo === "manual"` escondía 111 notas de
 * proveedor y 47 de correo.
 */

export const EVENTOS_CONVERSACION = new Set([
  "caso.jimi_ticket",
  "caso.queclink_ticket",
  "correo.entrante",
  "correo.enviado",
  "correo.zendesk",
  // Suenan a tarea interna, pero su nota trae el CUERPO del correo del cliente:
  // los tres caminos que pegan un correo a un caso comparten receta y solo
  // cambian el encabezado. Ver el comentario largo del lado de Python.
  "correo.asignado",
  "triage.vinculado_ia",
]);

/** ¿Esta nota es parte del hilo con el cliente o el proveedor? */
export function esConversacion(tipo: string, evento: string | null): boolean {
  if (tipo === "manual") return true;
  return EVENTOS_CONVERSACION.has(evento ?? "");
}
